import React, { useState, useCallback, useEffect } from "react";

const internationalCodes = [
  { code: "+234", countryCode: "NG" },
  { code: "+1", countryCode: "USA" },
  // Add more codes as needed
];

const StorePublicForm = ({
  publicUser,
  onBack,
  onSuccess,
  activateBackButton,
  cart,
}) => {
  useEffect(() => {
    activateBackButton(true, () => {
      onBack();
    });
  }, []);

  const [formData, setFormData] = useState({
    email: publicUser?.email || cart?.publicInfo?.email || "",
    firstName: publicUser?.firstName || cart?.publicInfo?.firstName || "",
    lastName: publicUser?.lastName || cart?.publicInfo?.lastName || "",
    phone: publicUser?.phone || cart?.publicInfo?.phone || "",
    intCode:
      publicUser?.intCode ||
      cart?.publicInfo?.intCode ||
      internationalCodes[0]?.code || "+234",
  });

  const [error, setError] = useState("");

  const isEmailValid = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  const isPhoneValid = (phone) => /^\d{6,15}$/.test(phone); // 6-15 digits recommended


  const handlePhoneChange = (e) => {
  const value = e.target.value.replace(/[^\d]/g, ""); // Strip non-digits
  setFormData((prev) => ({ ...prev, phone: value }));
  setError("");
};

  const handleChange = useCallback((e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    setError("");
  }, []);

  const handleRegisterSubmit = useCallback(
    (e) => {
      e.preventDefault();

      if (
        !formData.firstName ||
        !formData.lastName ||
        !formData.email ||
        !formData.phone
      ) {
        setError("Please fill in all fields.");
        return;
      }

      if (!isEmailValid(formData.email)) {
        setError("Please enter a valid email address.");
        return;
      }

      if (!isPhoneValid(formData.phone)) {
        setError("Please enter a valid phone number.");
        return;
      }

      const trimmedFormData = {
        ...formData,
        email: formData.email.trim(),
        firstName: formData.firstName.trim(),
        lastName: formData.lastName.trim(),
        phone: formData.phone.trim(),
      };

      onSuccess(trimmedFormData);
      setError("");
    },
    [formData, onSuccess]
  );

  return (
    <>
      <div className="auth-form-container">
        <h2>Shipping Information</h2>
        {error && <div className="error-message" role="alert">{error}</div>}
        <form onSubmit={handleRegisterSubmit}>
          <div className="input-box">
            <label htmlFor="firstName">First Name:</label>
            <div className="input-text">
              <input
                type="text"
                id="firstName"
                name="firstName"
                aria-label="Enter your first name"
                required
                placeholder="First Name"
                value={formData.firstName}
                onChange={handleChange}
              />
            </div>
          </div>
          <div className="input-box">
            <label htmlFor="lastName">Last Name:</label>
            <div className="input-text">
              <input
                type="text"
                id="lastName"
                name="lastName"
                aria-label="Enter your last name"
                placeholder="Last Name"
                value={formData.lastName}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="input-box">
            <label htmlFor="email">Email:</label>
            <div className="input-text">
              <input
                type="email"
                id="email"
                name="email"
                aria-label="Enter your email"
                required
                placeholder="Email"
                value={formData.email}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="input-box">
            <label htmlFor="phone">Phone Number:</label>
            <div className="input-text">
              <select
                id="intCode"
                name="intCode"
                value={formData.intCode}
                onChange={handleChange}
                aria-label="Select international code"
                required
              >
                {internationalCodes.map((code) => (
                  <option key={code.code} value={code.code}>
                    {code.code} ({code.countryCode})
                  </option>
                ))}
              </select>
              <input
                type="text"
                id="phone"
                name="phone"
                aria-label="Enter your phone number"
                value={formData.phone}
                onChange={handlePhoneChange}
                required
                placeholder="Enter your phone number"
              />
            </div>
          </div>

          <div className="login-container">
            <button
              type="submit"
              className="auth-submit-button"
              aria-label="Submit the form"
            >
              Continue
            </button>
          </div>
        </form>
      </div>
    </>
  );
};

export default StorePublicForm;
